export interface IFileManager {}

export default class FileManager implements IFileManager {
  constructor(obj: IFileManager) {
    Object.assign(this, obj);
  }

  static async convertFileToBase64(file: any): Promise<string | ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
    });
  }
}
